import * as React from 'react';

import AtlasFooter from './AtlasFooter';
import AtlasHeader from './AtlasHeader';

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <AtlasHeader />
      {children}
      <AtlasFooter />
    </>
  );
}
